export default {
    environment: 'debug',     //debug or online
    api: {
        url: 'https://api.shop.yuexiaoyao8.com',
        // websocket: 'wss://ws.yuexiaoyao8.com'
        websocket: 'ws://120.24.204.24:9590'
    }
}



// WEBPACK FOOTER //
// ./.config.js